const IndexadoresModule = {
    state: {
        indexadores: [],
        coresAtivos: [],
        quantidadeAtivos: 0
    },
    getters: {
        getIndexadores(state) {
            state.indexadores = [];
            // Os indexadores estão nos arquivos .env
            const string = "1;CDI|2;Ibovespa|3;Dolar|7;IPCA|2100105;Poupança";
            let indexadores = string.split("|");
            state.indexadores = indexadores.map(el => {
                let dados = el.split(";");
                return { codigoIndexador: Number.parseInt(dados[0]), nomeIndexador: dados[1], selecionado: dados[0] == 1 };
            })

            return state.indexadores;
        },
        getSelecionados(state) {
            return state.indexadores.filter(el => el.selecionado);
        },
        getCoresAtivos(state) {
            return state.coresAtivos;
        },
        getQuantidadeAtivos(state) {
            return state.quantidadeAtivos;
        }
    },
    mutations: {
        setIndexadores(state, indexadores) {
            state.indexadores = indexadores;
        },
        setSelecionados(state, indexadores) {
            state.indexadores.forEach(el => {
                el.selecionado = indexadores.includes(el.codigoIndexador);
            });
        },
        setCoresAtivos(state, cores) {
            state.coresAtivos = cores;
        },
        setQuantidadeAtivos(state, quantidade) {
            state.quantidadeAtivos = quantidade;
        },
        addAtivo(state) {
            state.quantidadeAtivos++;
        },
        removeAtivo(state) {
            state.quantidadeAtivos--;
        }
    },
    actions: {
        
    }
}

export default IndexadoresModule;